module.exports = __webpack_public_path__ + "static/img/default-hero.e481512.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-hero.jpg
// module id = DikZ
// module chunks = 1